import Alpine from 'alpinejs';

const HOVER_TOLERANCE_MS = 200;

Alpine.data('header', () => {
  const menuTimeouts = {};

  return {
    menu: {},

    handleHover(event) {
      const parent = event.target.parentElement;
      const menuItem = parent.dataset.menuItem;

      if (menuItem) {
        this.menu = {};
        this.menu[menuItem] = true;
      }
    },

    handleMouseEnter(event) {
      const parent = event.target;
      const menuItem = parent.dataset.menuItem;

      if (menuTimeouts[menuItem]) {
        clearTimeout(menuTimeouts[menuItem]);
      }
    },

    handleMouseLeave(event) {
      const parent = event.target;
      const menuItem = parent.dataset.menuItem;

      menuTimeouts[menuItem] = setTimeout(() => {
        if (menuItem) {
          this.menu[menuItem] = false;
        }
      }, HOVER_TOLERANCE_MS);
    },

    handleKeyDown(event) {
      const parent = event.target.parentElement;
      const menuItem = parent.dataset.menuItem;

      if (event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();

        if (this.menu[menuItem]) {
          // Close the menu
          this.menu = {};
          this.menu[menuItem] = false;
        } else {
          this.menu = {};
          this.menu[menuItem] = true;
        }
      }
    },

    handleFocusOut(event) {
      if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
        return;
      }

      const menuitem = event.currentTarget.dataset.menuItem;
      if (menuitem) {
        this.menu[menuitem] = false;
      }
    },

    openHamburger(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$dispatch('hamburger');
    },
  };
});

Alpine.data('hamburger', () => {
  let previousFocus = null;

  return {
    isOpen: false,
    focusHandler: null,
    clickOutsideHandler: null,
    menu: {},

    init() {
      this.focusHandler = this.handleFocusOutside.bind(this);
      this.clickOutsideHandler = this.handleClickOutside.bind(this);
    },

    handleFocusOutside(event) {
      if (!this.$refs.hamburger.contains(event.target)) {
        // Return focus to the hamburger
        this.$refs.homeLink?.focus();
      }
    },

    handleClickOutside(event) {
      if (!this.$refs.hamburger.contains(event.target)) {
        this.closeMenu();
      }
    },

    openMenu() {
      this.isOpen = true;
      document.body.classList.add('no-scroll');

      if (document.activeElement) {
        previousFocus = document.activeElement;
      }

      // Required to allow click focus event to complete first.
      setTimeout(() => {
        this.$refs.homeLink?.focus();
      });

      window.addEventListener('focusin', this.focusHandler);
      window.addEventListener('click', this.clickOutsideHandler);
    },

    closeMenu() {
      this.isOpen = false;
      document.body.classList.remove('no-scroll');

      window.removeEventListener('focusin', this.focusHandler);
      window.removeEventListener('click', this.clickOutsideHandler);

      if (previousFocus) {
        setTimeout(() => {
          previousFocus.focus();
        });
      }
    },

    toggleSubmenu(name) {
      if (this.menu[name]) {
        delete this.menu[name];
      } else {
        this.menu[name] = true;
      }
    },
  };
});
